import React from 'react';
import ReactDOM from 'react-dom';

import Application from './components/Application';
import ThemeProvider from '@ab/components/dest/components/themeProvider';

import {createStore, combineReducers, applyMiddleware} from 'redux';
import {Provider, connect} from 'react-redux';

import {createBrowserHistory} from 'history';

import {ConnectedRouter, connectRouter, routerMiddleware} from 'connected-react-router';
import theme from './palette';
import reducers from './reducers';

// Create a history of your choosing (we're using a browser history in this case)
const history = createBrowserHistory();

// Build the middleware for intercepting and dispatching navigation actions
const middleware = routerMiddleware(history);

// Add the reducer to your store on the `router` key
// Also apply our middleware for navigating
const store = createStore(
    combineReducers({
        router: connectRouter(history),
        ...reducers,
    }),
    applyMiddleware(middleware),
);

const onRouteChange = state => state;

const ApplicationRoot = connect(onRouteChange)(Application);

ReactDOM.render(
    <Provider store={store}>
        <ThemeProvider theme={theme}>
            <ConnectedRouter history={history}>
                <ApplicationRoot />
            </ConnectedRouter>
        </ThemeProvider>
    </Provider>,
    document.getElementById('app'),
);
